<router-outlet></router-outlet>
<div
  *ngIf="offline$ | async"
  class="app-overlay d-flex flex-column justify-content-center align-items-center"
>
  <img class="app-overlay-logo mt-5" src="assets/images/logo.png" />
  <dxc-empty
    dxcTitle="Oops!"
    dxcSubtitle="No Internet Connection"
    dxcContent="Please check your internet settings."
    dxcStatus="danger"
    dxcActionTitle="Refresh Page"
    dxcActionStatus="danger"
    class="my-auto"
    (dxcOnActionClick)="reloadApp()"
  />
</div>

<div
  *ngIf="(isAuthenticated || isEmbed) && idleState === 'COUNTDOWN'"
  class="session-overlay d-flex flex-column justify-content-center align-items-center"
>
  <img class="session-overlay-logo mt-5" src="assets/images/logo.png" />
  <dxc-empty
    dxcTitle="Session Timeout!"
    dxcSubtitle="Your session is about to expire"
    dxcContent="You will be logged out in {{ idleCountDown | intervalToDuration }}"
    dxcStatus="warning"
    dxcIcon="clock-solid"
    dxcActionTitle="Cancel"
    dxcActionStatus="warning"
    (dxcOnActionClick)="stopSessionTimer()"
    class="my-auto"
  />
</div>

<div
  class="app-update-banner text-center d-flex-column d-md-flex align-items-center justify-content-center"
  *ngIf="newVersionDetected"
>
  <dxc-icon dxcIcon="circle-down" />
  <p dxc-typography dxcWeight="normal" dxcType="white" class="mb-0 ms-2">
    New update is available! <a (click)="reloadApp()">reload now</a> to update.
  </p>
</div>
